import { toast } from "sonner";

// Registers the service worker in production builds only: in development it
// would serve stale bundles over the hot-reloading dev server.
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    let registration;
    try {
      registration = await navigator.serviceWorker.register(
        `${process.env.PUBLIC_URL}/service-worker.js`,
      );
    } catch {
      return; // the app works without it, just not offline or installed
    }

    if (registration.waiting) offerUpdate(registration.waiting);
    registration.addEventListener("updatefound", () => {
      const worker = registration.installing;
      worker?.addEventListener("statechange", () => {
        // With no controller this is the first install, not an update.
        if (worker.state === "installed" && navigator.serviceWorker.controller) {
          offerUpdate(worker);
        }
      });
    });

    // An installed app can stay open for days; look for a new build whenever
    // it comes back to the foreground.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") registration.update().catch(() => {});
    });
  });
}

let reloading = false;

function offerUpdate(worker) {
  toast("A new version of FinFlo is ready", {
    id: "sw-update",
    duration: Infinity,
    action: {
      label: "Reload",
      onClick: () => {
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloading) return;
          reloading = true;
          window.location.reload();
        });
        worker.postMessage({ type: "SKIP_WAITING" });
      },
    },
  });
}
